module.exports = __webpack_public_path__ + "static/media/new6.e1ecfe97.png";